import { describeSaveFailure } from "@/utils/describeSaveFailure";
import { ERROR_TYPE, translateError } from "@/utils/errors";
import { readApiErrorCode } from "@/utils/lifecycleErrors";

/**
 * The line the source form shows when saving or previewing a source is refused.
 *
 * A source that names a private list is refused by the API (`SMART_LIST_PRIVATE_LIST`, PREC-4723):
 * the daily run has no user, so it sees PUBLIC lists only and would read "From list: <my private
 * list>" as no list. That refusal is said in words; any other is the fallback plus the API's reason.
 */
export function sourceRequestErrorMessage(error: unknown, fallback: string): string {
	if (readApiErrorCode(error) === ERROR_TYPE.SMART_LIST_PRIVATE_LIST) {
		return translateError[ERROR_TYPE.SMART_LIST_PRIVATE_LIST];
	}

	return describeSaveFailure(error, fallback);
}
